function setSettingsParams(filters: ISettingsSearchParams) {
  const params: ISettingsSearchParams = {};
  if (filters.pvAccountID) {
    params.pvAccountID = filters.pvAccountID;
  }
  if (filters.pvSettingType) {
    params.pvSettingType = filters.pvSettingType;
  }
  if (filters.pvGroupID) {
    params.pvGroupID = filters.pvGroupID;
  }
  return params;
}

export default setSettingsParams;
